
import commonUtils from "@/utils/common.utils";

export default class bounsModel {
    constructor(bonus) {
        let orderNumberList = bonus?.order_number ? bonus.order_number.split(':') : []
        this.comment = bonus.comment
        this.createdAt = bonus?.created_at ? commonUtils.convertDateTime(bonus.created_at) : ''
        this.decrease = bonus.decrease
        this.increase = bonus.increase
        this.mobile = bonus.mobile_phone
        this.name = bonus.name
        this.operator = bonus.operator
        this.orderNumber = orderNumberList[0] ? orderNumberList[0] : ""
        this.reason = bonus.reason
        this.rpNumber = bonus.rp_number
        this.storeComment = bonus.store_comment
        this.storeMemberUUID = bonus.store_member_uuid
    }
}